// extracted by mini-css-extract-plugin
export default {"base":"Timeout_base__yoNAp","timeout_text":"Timeout_timeout_text__RgJ7A","modal_content":"Timeout_modal_content__7fxcP","heading":"Timeout_heading__Hyp-j"};